import { useTranslation } from 'react-i18next';
import type { NoteDeleteControls } from '@/features/notes/editor/useNoteDelete';

/** Formularul de confirmare a ștergerii — doar afișare; starea e în `useNoteDelete`. */
export function NoteDeleteConfirm({
  pwdInput,
  setPwdInput,
  pwdError,
  busy,
  deleting,
  submitDelete,
  cancelDelete,
}: Pick<
  NoteDeleteControls,
  'pwdInput' | 'setPwdInput' | 'pwdError' | 'busy' | 'deleting' | 'submitDelete' | 'cancelDelete'
>) {
  const { t } = useTranslation();
  return (
    <form
      onSubmit={submitDelete}
      className="mt-4 pt-3 border-t border-red-200 dark:border-red-900/50 space-y-3"
    >
      <p className="text-sm text-red-700 dark:text-red-300 font-medium">
        {t('notes_ui.editor.delete_confirm_title')}
      </p>
      <p className="text-xs text-[var(--text-muted)]">
        {t('notes_ui.editor.delete_confirm_hint')}
      </p>
      <input
        type="password"
        className="input font-mono"
        placeholder={t('auth.master_password')}
        value={pwdInput}
        onChange={(e) => setPwdInput(e.target.value)}
        autoFocus
        disabled={busy || deleting}
      />
      {pwdError && (
        <div className="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded px-3 py-2">
          {pwdError}
        </div>
      )}
      <div className="flex gap-2">
        <button
          type="submit"
          className="btn bg-red-600 text-white hover:bg-red-700 text-sm"
          disabled={busy || deleting}
        >
          {busy
            ? t('notes_ui.editor.verifying_password')
            : deleting
              ? t('notes_ui.editor.deleting')
              : t('notes_ui.editor.delete_permanently')}
        </button>
        <button
          type="button"
          className="btn-outline text-sm"
          onClick={cancelDelete}
          disabled={busy || deleting}
        >
          {t('common.cancel')}
        </button>
      </div>
    </form>
  );
}
